
jQuery(document).ready(function($) {
  
  jQuery('.main').removeClass('container'); 
    $('#registration-form').bootstrapValidator({
        live: 'enabled',
        submitHandler: function(validator, form, submitButton) {

            //return false;
        },
        feedbackIcons: {
            valid: 'glyphicon glyphicon-ok',
            invalid: 'glyphicon glyphicon-remove',
            validating: 'glyphicon glyphicon-refresh'
        },
        framework: 'bootstrap',
        icon: {
            valid: 'fa fa-check',
            invalid: 'fa fa-times',
            validating: 'fa fa-refresh'
        },
        fields: {
            uemail: {
                validators: {
                    notEmpty: {
                        message: 'The email address is required'
                    },
                    emailAddress: {
                        message: 'The input is not a valid email address'
                    }
                }
            },
            uname: {
                validators: {
                    notEmpty: {
                        message: 'The Name is required'
                    }
                }
            },

            uwebsite: {
                validators: {
                    notEmpty: {
                        message: 'The Website is required'
                    }
                }
            },
            uorder: {
                validators: {
                    notEmpty: {
                        message: 'The Order is required'
                    }
                }
            },
            uwarranty: {
                validators: {
                    notEmpty: {
                        message: 'The Warranty is required'
                    }
                }
            }
        }
    }).on('success.form.bv', function(e) { 
        // // Prevent form submission
				jQuery('.loading').show();
     
				var data = $("#registration-form :input[value!='']").serialize();
      			data = data+'&source=kaluns';
      			console.log(data);
     			e.preventDefault();
				$.ajax({
  						type: 'POST',
						url: 'https://registergrowgreen.com/wp-admin/admin-ajax.php',
						data: { action:'registerSubmit', data:data},
						success: function(result) {
                         
							  var obj = jQuery.parseJSON(result);
								if (obj.status == true && obj.amazon == true) {
									  setTimeout(function(){
											jQuery('#warranty_form').css('display','');
											jQuery('#register_form').hide();
											jQuery('.head-image').hide();
											jQuery("#content").height(jQuery(document).height()-145);
											jQuery('input[name="userid"]').val(obj.id);
											jQuery('.head-image').hide();
										},1500);

								} else if (obj.status == true && obj.amazon == false && obj.code != '') {
                                   //jQuery(".img-main").attr("src", "https://cdn.shopify.com/s/files/1/0042/8467/8234/t/1/assets/thankshuman.png");
											jQuery('#register_form').hide();
											jQuery('.head-image').hide();
											jQuery("#content").height(jQuery(document).height()-145);
											jQuery('#code_form').show();
											 jQuery('body').find('input').val('');
											jQuery('input[name="ccode"]').val(obj.code);
                                  
                                
                                  
                                 			jQuery('.coupon-box span').text(obj.code);
                                  	jQuery('.register-page').next().hide();
                                  			jQuery('.register-page').hide();
                                  		
                                   jQuery("#main").addClass('col-md-12').removeClass('col-md-6');
                                  
                                  			jQuery('.thanks-page').show();
                                  
                                  jQuery('.thanks-page').removeClass('thanks-page');
											jQuery('.congrats-panel span').css('font-size','20px');
											jQuery('.with-amazon').remove();
											
											jQuery('.25per').hide();
											//jQuery('.congrats-panel span').text('10% Off growgreenbrands.com');
											//jQuery('.head-image').hide();
								} else {

								}
								setTimeout(function(){ jQuery('.loading').hide()},1500);
						}, error: function(e){console.log( e );},
				});
			  e.preventDefault();
    });

		jQuery('#warranty_submit').click(function(){
					if(jQuery('input[name="userid"]').val() == '' || jQuery('input[name="ureviewlink"]').val() == '' ) {
						jQuery('.url-errori').show();
						jQuery('.url-error').show();
						jQuery('.url-error').text('The review link required.');
					} else {
						jQuery('.loading').show();
						var userid = jQuery('input[name="userid"]').val();
						var ureviewlink = jQuery('input[name="ureviewlink"]').val();
						var url_validation = isURL(ureviewlink);
						//if(url_validation != false) {
								$.ajax({
										type: 'POST',
										url: 'http://registergrowgreen.com/wp-admin/admin-ajax.php',
										data: { action:'warrantySubmit',ureviewlink:ureviewlink,userid:userid},
										success: function(result) {
											  jQuery('.head-image').hide();
											 jQuery("#content").height(jQuery(document).height()-145);
											  var obj = jQuery.parseJSON(result);
												if (obj.status == true) {
														setTimeout(function(){
															jQuery('.non-amazon').remove();
															jQuery('.loading').hide();
															jQuery('#warranty_form').hide();
															jQuery('#register_form').hide();
															jQuery('.head-image').hide();
															jQuery('#code_form').show();
															jQuery('body').find('input').val('');
															jQuery('input[name="ccode"]').val(obj.code);
														},1500);
												} else if (obj.hide) {
														jQuery('.already-error').show();
														jQuery('.already-error').css('style','');
														jQuery('#warranty-form').hide();
												} else {
															jQuery('.url-errori').show();
															jQuery('.url-error').show();
															jQuery('.url-error').text(obj.message);
															jQuery('.loading').hide();
												}
												setTimeout(function(){ jQuery('.loading').hide()},1500);
										}
								});
								setTimeout(function(){ jQuery('.loading').hide()},1500);
							//}
					}
		});


		if(jQuery("input[name='userid']").val() != '') {
	jQuery('#warranty_form').show();
	jQuery("#register_form").hide();
	jQuery('#code_form').hide();
}


});


function isURL(str) {
		var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
		'(\\#[-a-z\\d_]*)?$','i'); // fragment locator
		return pattern.test(str);
}

function copyCoupon() {
	var copyText = document.getElementById("myCoupon");

  /* Select the text field */
  copyText.select();

  /* Copy the text inside the text field */
  document.execCommand("Copy");

  /* Alert the copied text */
  alert("Copied the coupon: " + copyText.value);
}

if(jQuery(".with-amazon input[name='ccode']").val() != '') {

	jQuery("#register_form").hide();
	jQuery("#warranty_form").hide();

jQuery('#code_form').show();
	jQuery(".non-amazon").hide();
	jQuery(".with-amazon").show();
}

if(jQuery(".non-amazon input[name='ccode']").val() != '') {

	jQuery("#register_form").hide();
	jQuery("#warranty_form").hide();
	
	jQuery('#code_form').show();
	jQuery(".non-amazon").show();
	jQuery(".with-amazon").hide();
	
}
